import { render } from "./User-C007.vue?vue&type=template&id=55dae9b2&scoped=true"
const script = {}

import "./User-C007.vue?vue&type=style&index=0&id=55dae9b2&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/mobile-mpe-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55dae9b2"]])

export default __exports__